import { StudentAchievement } from "@services/dtos/school.dto";
import { useThemeStore } from "@stores/theme.store";
import { useDetailState } from "@utils/detail_state";
import { linkPage } from "@utils/router";
import moment from "moment";
import { useEffect } from "react";

export const StudentAchievementDetailPage = () => {
  const state = useDetailState<StudentAchievement>(
    linkPage.SCHOOL_STUDENT_ACHIEVEMENT
  );
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Prestasi",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Prestasi", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  if (!state) return null;

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal Prestasi</div>
        <div className="color-theme mb-3">{moment(state.tanggal ?? Date.now()).format('dddd, DD MMMM YYYY | HH:mm')}</div>
        <div className="color-highlight">Prestasi Diberikan</div>
        <div className="color-theme mb-3">{state.prestasi ?? '-'}</div>
        <div className="color-highlight">Apresiasi Prestasi</div>
        <div className="color-theme mb-3">{state.apresiasi ?? '-'}</div>
        <div className="color-highlight">Pengurangan Poin</div>
        <div className="color-theme mb-3">{state.poin} Poin</div>
        <div className="color-highlight">Catatan</div>
        <div className="color-theme mb-3">{state.catatan ?? '-'}</div>
      </div>
    </div>
  );
};
